import React from 'react';
import './featureContent.css';

/**
 * Hero section for a Feature page.
 * @param {string} eyebrow - small label above the title (optional)
 * @param {string} title - main title text (plain, non-highlighted part)
 * @param {string} highlight - portion of the title rendered in accent color (optional)
 * @param {string} subtitle - supporting paragraph
 * @param {React.ReactNode} cta - call-to-action button/link
 * @param {string} note - small note under the CTA (e.g. "Available on mobile")
 * @param {React.ReactNode} image - optional visual (e.g. FeatureScreenshot) rendered
 *   alongside the text in a two-column layout. When omitted, text is centered.
 * @param {string} className - extra class(es) applied to the section element
 */
function FeatureHero({ eyebrow, title, highlight, subtitle, cta, note, image, className = '' }) {
    const textBlock = (
        <div className="fc-hero-inner">
            {eyebrow && <div className="fc-hero-eyebrow">{eyebrow}</div>}
            <h1 className="h-1 h-bold fc-hero-title">
                {title}{highlight && <> <span className="fc-hero-highlight">{highlight}</span></>}
            </h1>
            {subtitle && <p className="fc-hero-subtitle">{subtitle}</p>}
            {cta}
            {note && <p className="fc-hero-note">{note}</p>}
        </div>
    );

    if (!image) {
        return (
            <section className={`fc-hero sp-60${className ? ` ${className}` : ''}`}>
                <div className="container">
                    {textBlock}
                </div>
            </section>
        );
    }

    return (
        <section className={`fc-hero fc-hero-split sp-60${className ? ` ${className}` : ''}`}>
            <div className="container">
                <div className="fc-hero-split-row">
                    <div className="fc-hero-split-text">{textBlock}</div>
                    <div className="fc-hero-split-image">{image}</div>
                </div>
            </div>
        </section>
    );
}

export default FeatureHero;
